/**
 * Student Knowledge Map domain group node.
 * Renders a labeled container for domain groupings in the knowledge map.
 */

import { memo } from 'react'

function DomainGroupNodeComponent({ data }) {
  const { label, test_type, nodeCount, width, height, masteryStats } = data

  const isMath = test_type === 'math'
  const borderColor = isMath ? '#93c5fd' : '#c4b5fd'
  const bgColor = isMath ? 'rgba(219, 234, 254, 0.3)' : 'rgba(237, 233, 254, 0.3)'
  const headerColor = isMath ? '#2563eb' : '#7c3aed'

  // Mastery badge color
  const masteredCount = masteryStats?.mastered || 0
  const totalCount = masteryStats?.total || nodeCount || 0
  const masteryPercent = totalCount > 0 ? (masteredCount / totalCount) * 100 : 0
  let badgeBg, badgeText
  if (masteryPercent >= 100) {
    badgeBg = '#DCFCE7'
    badgeText = '#166534'
  } else if (masteryPercent >= 50) {
    badgeBg = '#FEF3C7'
    badgeText = '#92400E'
  } else {
    badgeBg = '#F3F4F6'
    badgeText = '#6B7280'
  }

  return (
    <div
      style={{
        width: width || 300,
        height: height || 200,
        border: `1.5px dashed ${borderColor}`,
        borderRadius: 12,
        backgroundColor: bgColor,
        padding: 0,
        pointerEvents: 'none'
      }}
    >
      <div
        style={{
          padding: '8px 14px',
          fontSize: 12,
          fontWeight: 600,
          color: headerColor,
          letterSpacing: '0.02em',
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }}
      >
        <span>{label}</span>
        {totalCount > 0 && masteryStats && (
          <span
            title={`${masteredCount} mastered, ${masteryStats.inProgress || 0} in progress, ${masteryStats.struggling || 0} struggling, ${masteryStats.unvisited || 0} unvisited`}
            style={{
              fontSize: 10,
              fontWeight: 600,
              color: badgeText,
              backgroundColor: badgeBg,
              padding: '1px 8px',
              borderRadius: 8
            }}
          >
            {masteredCount}/{totalCount} mastered
          </span>
        )}
        {totalCount > 0 && !masteryStats && (
          <span
            style={{
              fontSize: 10,
              fontWeight: 500,
              color: '#6b7280',
              backgroundColor: 'rgba(255,255,255,0.7)',
              padding: '1px 6px',
              borderRadius: 8
            }}
          >
            {nodeCount}
          </span>
        )}
      </div>
    </div>
  )
}

export const DomainGroupNode = memo(DomainGroupNodeComponent)
